import { BaseModel } from '../common/base-model/base-model';
import { AttendantServiceGroupServices } from '../attendant-service-group-services/attendant-service-group-services';

export class AttendantServiceGroups extends BaseModel {
  constructor(
    public override id?: string,
    public attendant_id?: string,
    public service_group_id?: string,
    public deleted?: boolean,
    public attendants_service_groups_services?: AttendantServiceGroupServices[],
  ) {
    super();
  }

  toJSON() {
    return {
      id: this.id,
      attendant_id: this.attendant_id,
      service_group_id: this.service_group_id,
      deleted: !!this.deleted,
      attendants_service_groups_services:
        this.attendants_service_groups_services?.map((item) => item.toJSON()) ||
        [],
    };
  }

  static fromJson(jsonData: any): AttendantServiceGroups {
    const attendantServiceGroup = Object.assign(
      new AttendantServiceGroups(),
      jsonData,
    );

    if (
      jsonData.attendants_service_groups_services &&
      Array.isArray(jsonData.attendants_service_groups_services)
    ) {
      attendantServiceGroup.attendants_service_groups_services =
        jsonData.attendants_service_groups_services.map((item: any) =>
          AttendantServiceGroupServices.fromJson(item),
        );
    }

    return attendantServiceGroup;
  }
}
